import { useConfig } from 'components/ui'

const LEVELS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]
const DEFAULT_LEVEL = 600

/** Step N places along the Tailwind scale, clamped at both ends. */
const step = (level, by) => {
    const at = LEVELS.indexOf(Number(level))
    const from = at === -1 ? LEVELS.indexOf(DEFAULT_LEVEL) : at
    return LEVELS[Math.min(LEVELS.length - 1, Math.max(0, from + by))]
}

/**
 * Accent classes for the theme colour the user picked in the theme configurator
 * (17 colours x 6 levels; indigo-600 by default).
 *
 * NOTE this is for ACCENTS — icons, links, chips, rings, selected-card borders.
 * BUTTONS do not belong here: the project has its own button system in app.css
 * (`cg-btn` primary, `cg-btn-default` grey, `cg-btn-danger` red), applied by the
 * shared <Button> via its `variant` / `danger` props. Those rules use !important,
 * so a Tailwind colour class on a button is silently dead — which is exactly how
 * the invoice screen ended up with every button grey.
 */
function useThemeClass() {

    const { themeColor, primaryColorLevel } = useConfig()
    const color = `${themeColor}-${primaryColorLevel}`
    const hoverLevel = step(primaryColorLevel, 1)

    return {
        ringTheme: `ring-${color}`,
        borderTheme: `border-${color}`,
        bgTheme: `bg-${color}`,
        textTheme: `text-${color}`,

        // Variants screens used to hardcode as indigo-*, which silently ignored the
        // colour the user picked. All are covered by safelist.txt, so they survive
        // Tailwind's JIT purge.
        bgThemeHover: `hover:bg-${themeColor}-${hoverLevel}`,
        bgThemeSoft: `bg-${themeColor}-50`,
        bgThemeSoftHover: `hover:bg-${themeColor}-50`,
        textThemeHover: `hover:text-${color}`,
        ringThemeFocus: `focus:ring-${color}`,
        borderThemeFocus: `focus:border-${color}`,
        ringThemeSoft: `ring-${themeColor}-200`,
        borderThemeSoft: `border-${themeColor}-200`,
    }
}

export default useThemeClass
